
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/write-headings",
      function () {
        return require("private-next-pages/app/tools/write-headings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/write-headings"])
      });
    }
  